/**
 * Sifrah Beauty · landing aprobada: categorías, test de ritual, virales y vista rápida (Tikual).
 * Lee los productos de la colección o, en borrador, del respaldo de demostración.
 */
(function () {
  'use strict';

  var CHEVRON = '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="m6 9 6 6 6-6" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>';

  var QUIZ = [
    { k: 'area', q: '¿Qué quieres consentir hoy?', o: [
      { v: 'rostro', t: 'Mi rostro', s: 'Mascarillas y glow' },
      { v: 'labios', t: 'Mis labios', s: 'Suaves y jugosos' },
      { v: 'manos', t: 'Manos y uñas', s: 'Hidratación y manicure' },
      { v: 'aroma', t: 'Mi aroma', s: 'Oler rico todo el día' },
      { v: 'cuerpo', t: 'Mi cuerpo', s: 'Piel suave y perfumada' },
      { v: 'regalo', t: 'Busco un regalo', s: 'Para alguien especial' } ] },
    { k: 'need', q: null, by: {
      rostro: { q: '¿Cómo sientes tu piel?', o: [
        { v: 'rostro-seca', t: 'Seca o tirante', s: 'Le falta hidratación' },
        { v: 'rostro-grasa', t: 'Grasa o con poros', s: 'Brilla a media tarde' },
        { v: 'rostro-apagada', t: 'Apagada o cansada', s: 'Sin glow' },
        { v: 'rostro-sensible', t: 'Sensible', s: 'Se enrojece fácil' },
        { v: 'rostro-sol', t: 'Protegerme del sol', s: 'Barra fácil de reaplicar' } ] },
      labios: { q: '¿Qué quieres para tus labios?', o: [
        { v: 'labios-secos', t: 'Que dejen de resecarse', s: 'Pielecitas y grietas' },
        { v: 'labios-brillo', t: 'Que se vean jugosos', s: 'Brillo y volumen' } ] },
      manos: { q: '¿Qué necesitas?', o: [
        { v: 'manos-secas', t: 'Manos suaves', s: 'Se resecan con el lavado' },
        { v: 'unas', t: 'Uñas que duren', s: 'Acabado de salón en casa' } ] },
      aroma: { q: '¿Qué aroma te representa?', o: [
        { v: 'aroma-frutal', t: 'Frutal y jugoso', s: 'Alegre y fresco' },
        { v: 'aroma-fresco', t: 'Fresco y limpio', s: 'Recién bañada' },
        { v: 'aroma-dulce', t: 'Dulce', s: 'Coqueto y suave' },
        { v: 'aroma-cremoso', t: 'Cremoso y cálido', s: 'Envolvente' } ] },
      cuerpo: { q: '¿Qué le pide tu piel?', o: [
        { v: 'cuerpo-seca', t: 'Hidratación', s: 'La siento seca' },
        { v: 'cuerpo-aspera', t: 'Renovarse', s: 'La siento áspera' },
        { v: 'cuerpo-glow', t: 'Brillo y aroma', s: 'Quiero que luzca' } ] },
      regalo: { q: '¿Qué le encanta a esa persona?', o: [
        { v: 'aroma', t: 'Los perfumes', s: 'Siempre huele rico' },
        { v: 'labios', t: 'Sus labios', s: 'Nunca sin bálsamo' },
        { v: 'rostro', t: 'Cuidarse la piel', s: 'Fan de las mascarillas' },
        { v: 'cuerpo', t: 'Cuidar su cuerpo', s: 'Cremas y brumas' },
        { v: 'unas', t: 'Las uñas', s: 'Siempre impecables' } ] }
    } },
    { k: 'budget', q: '¿Cuánto quieres invertir?', o: [
      { v: '30', t: 'Hasta S/ 30', s: 'Un detalle' },
      { v: '80', t: 'De S/ 30 a S/ 80', s: 'Un ritual completo' },
      { v: '999', t: 'Lo que haga falta', s: 'Consentirme de verdad' } ] }
  ];

  var NAMES = {
    'rostro-seca': 'Ritual Nube', 'rostro-grasa': 'Ritual Fresco', 'rostro-apagada': 'Ritual Glow', 'rostro-sensible': 'Ritual Calma', 'rostro-sol': 'Ritual Escudo',
    'labios-secos': 'Ritual Labios de Seda', 'labios-brillo': 'Ritual Labios Jugosos', 'manos-secas': 'Ritual Manos Suaves', 'unas': 'Ritual Salón en Casa',
    'aroma-frutal': 'Ritual Aroma Juicy', 'aroma-fresco': 'Ritual Aroma Fresco', 'aroma-dulce': 'Ritual Aroma Dulce', 'aroma-cremoso': 'Ritual Aroma Cremoso',
    'cuerpo-seca': 'Ritual Piel de Seda', 'cuerpo-aspera': 'Ritual Renueva', 'cuerpo-glow': 'Ritual Glow Corporal'
  };

  /*pick:start*/
  var ROUTES = {
    'rostro-seca': ['Mascarilla', 'Mascarilla', 'Protección'],
    'rostro-grasa': ['Exfolia', 'Mascarilla', 'Mascarilla', 'Protección'],
    'rostro-apagada': ['Exfolia', 'Mascarilla', 'Mascarilla', 'Protección@rostro-sol'],
    'rostro-sensible': ['Mascarilla', 'Mascarilla', 'Protección'],
    'rostro-sol': ['Protección', 'Mascarilla@rostro'],
    'labios-secos': ['Set labios', 'Labios', 'Labios'],
    'labios-brillo': ['Set labios', 'Labios', 'Labios'],
    'manos-secas': ['Manos', 'Set uñas@unas'],
    'unas': ['Set uñas', 'Base', 'Brillo', 'Prepara'],
    'aroma-frutal': ['Set cuerpo', 'Hidrata', 'Aroma', 'Manos'],
    'aroma-fresco': ['Hidrata', 'Aroma', 'Aroma en tu cartera@aroma'],
    'aroma-dulce': ['Set cuerpo', 'Aroma', 'Hidrata', 'Aroma en tu cartera', 'Manos'],
    'aroma-cremoso': ['Set cuerpo', 'Hidrata', 'Aroma', 'Aroma en tu cartera', 'Manos'],
    'cuerpo-seca': ['Ducha', 'Hidrata', 'Glow'],
    'cuerpo-aspera': ['Exfolia', 'Hidrata', 'Ducha'],
    'cuerpo-glow': ['Glow', 'Aroma']
  };

  /* Elige una rutina sin repetir pasos, dentro del presupuesto y solo con productos disponibles.
     Si nada cabe, devuelve la opción más económica y marca over para decírselo a la clienta. */
  function pickRitual(P, ans) {
    var budget = Number(ans.budget) || 999, gift = ans.area === 'regalo', need = ans.need;
    var ok = P.filter(function (p) { return p.available !== false; });
    var has = function (p, t) { return (p.quiz || []).indexOf(t) > -1; };
    var byPrice = function (a, b) { return a.price - b.price; };
    if (gift) {
      var sets = ok.filter(function (p) { return has(p, need) && has(p, 'regalo') && p.price <= budget; }).sort(function (a, b) { return b.price - a.price; });
      if (sets.length) return { items: [sets[0]], over: false };
      var loose = ok.filter(function (p) { return has(p, need) && p.paso !== 'Protección'; }).sort(function (a, b) { return b.price - a.price; }), out = [], s = 0;
      loose.forEach(function (p) { if (out.length < 3 && s + p.price <= budget) { out.push(p); s += p.price; } });
      return out.length ? { items: out, over: false } : { items: loose.slice(-1), over: true };
    }
    var chosen = [], used = {}, sum = 0, line = '', route = ROUTES[need] || [], hasSet = false;
    var lead = ok.filter(function (p) { return p.paso === route[0] && has(p, need); }).sort(byPrice);
    if (need === 'rostro-sol' && lead[0] && lead[0].price > budget) return { items: lead.slice(0, 1), over: true };
    route.forEach(function (step) {
      if (chosen.length >= 4) return;
      var a = step.split('@'), tag = a[1] || need;
      if (hasSet && (a[0] === 'Hidrata' || a[0] === 'Aroma')) return;
      var c = ok.filter(function (p) { return p.paso === a[0] && has(p, tag) && !used[p.handle] && sum + p.price <= budget; });
      /* primero la misma línea; luego el producto cuyo tipo de piel o aroma (según la ficha) encaja más directo con la respuesta; luego el precio */
      var fit = function (x) { return x.quiz.indexOf(tag); };
      c.sort(function (x, y) { return (line ? (x.linea === line ? 0 : 1) - (y.linea === line ? 0 : 1) : 0) || fit(x) - fit(y) || byPrice(x, y); });
      var p = c[0]; if (!p) return;
      chosen.push(p); used[p.handle] = 1; sum += p.price; line = line || p.linea || '';
      (p.contiene || []).forEach(function (h) { used[h] = 1; hasSet = true; });
    });
    if (chosen.length) return { items: chosen, over: false };
    return { items: (lead.length ? lead : ok.filter(function (p) { return has(p, need); }).sort(byPrice)).slice(0, 1), over: true };
  }
  /*pick:end*/

  var CATS = [
    ['facial', 'Cuidado facial'], ['labios', 'Labios'], ['fragancias', 'Fragancias'],
    ['cuerpo', 'Cuidado corporal'], ['unas', 'Uñas'], ['sets', 'Sets y regalos']
  ];
  function catOf(p) {
    if (p.paso === 'Protección' || p.type === 'Cuidado Facial') return 'facial';
    if (p.type === 'Fragancias') return 'fragancias';
    if (p.type === 'Labios') return 'labios';
    if (p.type === 'Uñas') return 'unas';
    return 'cuerpo';
  }

  function init(root) {
    var $ = function (s) { return root.querySelector(s); };
    var $$ = function (s) { return Array.prototype.slice.call(root.querySelectorAll(s)); };
    var parse = function (s) { try { return JSON.parse(($(s) || {}).textContent || '[]'); } catch (e) { return []; } };
    var live = parse('[data-sb-products]'), preview = live.length === 0;
    var P = (preview ? parse('[data-sb-fallback]') : live).map(function (p) { p.price = Number(p.price) || 0; p.quiz = p.quiz || []; p.como = p.como || []; return p; });
    var FREE = Number(root.dataset.freeShip) || 0;
    var byH = function (h) { return P.filter(function (p) { return p.handle === h; })[0]; };
    var soles = function (n) { return 'S/ ' + n.toFixed(2); };
    var esc = function (s) { return String(s == null ? '' : s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); };
    var pic = function (p, w) { return p.img ? '<img src="' + esc(p.img) + '" alt="' + esc(p.title) + '" loading="lazy" width="' + w + '" height="' + w + '">' : '<span class="sb-noimg">' + esc(p.vendor) + '</span>'; };
    var RM = window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches;
    var toastT;
    function toast(m) { var t = $('[data-sb-toast]'); t.textContent = m; t.classList.add('is-on'); clearTimeout(toastT); toastT = setTimeout(function () { t.classList.remove('is-on'); }, 3600); }

    /* ---------- carrito ---------- */
    function addToCart(hs, btn) {
      var items = hs.map(byH).filter(function (p) { return p && p.variant; });
      if (!items.length) { toast('Demostración: los productos aún están en borrador y no se pueden comprar.'); return; }
      if (btn) { btn.disabled = true; btn.dataset.label = btn.textContent; btn.textContent = 'Agregando…'; }
      fetch('/cart/add.js', {
        method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: items.map(function (p) { return { id: Number(p.variant), quantity: 1 }; }) })
      }).then(function (r) { return r.text().then(function (t) { var j = {}; try { j = JSON.parse(t); } catch (e) {} return { ok: r.ok, j: j }; }); }).then(function (res) {
        if (!res.ok) { toast(res.j.description || 'No se pudo agregar. Revisa el stock.'); return; }
        document.dispatchEvent(new CustomEvent('theme:product:added', { bubbles: true, detail: res.j }));
        document.dispatchEvent(new CustomEvent('theme:cart:change', { bubbles: true }));
        var ci = document.querySelector('cart-items'); if (ci && typeof ci.getCart === 'function') ci.getCart();
        var dr = document.querySelector('cart-drawer');
        if (dr && typeof dr.openCartDrawer === 'function') dr.openCartDrawer(); else window.location.href = '/?open-cart=1';
      }).catch(function () { toast('No se pudo agregar a la bolsa. Inténtalo de nuevo.'); }).then(function () { if (btn) { btn.disabled = false; btn.textContent = btn.dataset.label; } });
    }

    /* ---------- tarjeta y vista rápida ---------- */
    /* tarjeta: la foto y el nombre llevan a la ficha; «Vista rápida» abre el detalle sin salir de la página */
    function card(p) {
      var url = esc(p.url || ('/products/' + p.handle));
      return '<article class="sb-card"><div class="sb-card__media"><a class="sb-card__ph" href="' + url + '" aria-label="' + esc(p.title) + '">' + pic(p, 400) + '<span class="sb-tag">' + esc(p.badge || 'Lo nuevo') + '</span></a>' +
        '<button type="button" class="sb-card__qv" data-sb-view="' + esc(p.handle) + '">Vista rápida</button></div>' +
        '<small>' + esc(p.vendor) + '</small><h3><a href="' + url + '">' + esc(p.title) + '</a></h3><b class="sb-price">' + soles(p.price) + '</b>' +
        '<button type="button" class="sb-cta" data-sb-buy="' + esc(p.handle) + '">Comprar ahora</button></article>';
    }
    var qv = $('[data-sb-qv]');
    function view(h) {
      var p = byH(h); if (!p) return;
      qv.innerHTML = '<button type="button" class="sb-qv__x" data-sb-qv-close aria-label="Cerrar">×</button><div class="sb-qv__ph">' + pic(p, 600) + '</div><div class="sb-qv__b"><small>' + esc(p.vendor) + (p.pres ? ' · ' + esc(p.pres) : '') + '</small><h3>' + esc(p.title) + '</h3><b class="sb-price">' + soles(p.price) + '</b>' +
        '<h4>Para quién</h4><p>' + esc(p.quien) + '</p><h4>Para qué</h4><p>' + esc(p.que) + '</p>' +
        (p.como.length ? '<h4>Cómo se usa</h4><ol>' + p.como.map(function (s) { return '<li>' + esc(s) + '</li>'; }).join('') + '</ol>' : '') +
        '<div class="sb-qv__cta"><button type="button" class="sb-cta" data-sb-buy="' + esc(p.handle) + '">Comprar ahora · ' + soles(p.price) + '</button>' +
        '<a class="sb-qv__more" href="' + esc(p.url || ('/products/' + p.handle)) + '">Ver ficha completa</a>' + '</div></div>';
      if (qv.showModal) qv.showModal(); else qv.setAttribute('open', '');
      document.documentElement.style.overflow = 'hidden';
      qv.querySelector('.sb-qv__b').scrollTop = 0;
      /* fotos pequeñas: se agrandan como máximo 2,5 veces para que no se vean pixeladas */
      var im = qv.querySelector('.sb-qv__ph img');
      if (im) { var fit = function () { if (im.naturalWidth) im.style.width = Math.min(im.parentNode.clientWidth - 32, im.naturalWidth * 2.5) + 'px'; }; if (im.complete) fit(); else im.onload = fit; }
    }
    qv.addEventListener('close', function () { document.documentElement.style.overflow = ''; });
    qv.addEventListener('click', function (e) { if (e.target === qv || e.target.closest('[data-sb-qv-close]')) qv.close(); });

    /* ---------- panel por categoría ---------- */
    var panel = $('[data-sb-panel]');
    function openCat(k, scroll) {
      var list = P.filter(function (p) { return k === 'sets' ? p.set === true || p.set === 'true' : catOf(p) === k; });
      panel.hidden = false;
      panel.innerHTML = '<div class="sb-chips" role="group" aria-label="Filtrar por categoría">' + CATS.map(function (c) { return '<button type="button" data-sb-cat="' + c[0] + '" aria-pressed="' + (c[0] === k) + '">' + c[1] + '</button>'; }).join('') + '</div>' +
        '<div class="sb-grid">' + list.map(card).join('') + '</div>';
      $$('.sb-cat').forEach(function (b) { b.setAttribute('aria-pressed', b.dataset.sbCat === k); });
      if (scroll) panel.scrollIntoView({ behavior: RM ? 'auto' : 'smooth', block: 'start' });
    }

    /* ---------- test ---------- */
    var qi = 0, ans = {}, res = null, removed = {}, open = false;
    var card$ = $('[data-sb-quiz]');
    function qDef(i) { var q = QUIZ[i]; if (q.by) { var d = q.by[ans.area]; return { k: q.k, q: d.q, o: d.o }; } return q; }
    function renderQuiz() {
      if (qi >= QUIZ.length) { res = pickRitual(P, ans); removed = {}; open = false; return renderResult(); }
      var q = qDef(qi);
      card$.innerHTML = '<div class="sb-q__prog">' + QUIZ.map(function (_, i) { return '<span class="' + (i <= qi ? 'on' : '') + '"></span>'; }).join('') + '</div><small class="sb-q__n">PREGUNTA ' + (qi + 1) + ' DE ' + QUIZ.length + '</small><p class="sb-q__t">' + esc(q.q) + '</p>' +
        '<div class="sb-q__opts">' + q.o.map(function (o) { return '<button type="button" data-v="' + esc(o.v) + '"><b>' + esc(o.t) + '</b><small>' + esc(o.s) + '</small></button>'; }).join('') + '</div>' +
        '<div class="sb-q__nav">' + (qi ? '<button type="button" data-back>Atrás</button>' : '<span></span>') + '<small>Toca una opción para seguir</small></div>';
    }
    function renderResult() {
      var name = ans.area === 'regalo' ? 'Tu regalo listo' : (NAMES[ans.need] || 'Tu ritual');
      var all = res.items, active = all.filter(function (p) { return !removed[p.handle]; });
      var total = active.reduce(function (a, p) { return a + p.price; }, 0);
      var left = FREE - total;
      card$.innerHTML = '<div class="sb-r"><small class="sb-q__n">TU RESULTADO</small><h3>' + esc(name) + '</h3>' +
        (res.over ? '<p class="sb-r__note">Este ritual empieza en ' + soles(all[0].price) + ', un poco más de lo que elegiste.</p>' : '') +
        '<button type="button" class="sb-r__toggle" data-sb-toggle aria-expanded="' + open + '"><span class="sb-r__thumbs">' + active.map(function (p) { return '<span>' + pic(p, 48) + '</span>'; }).join('') + '</span><span>' + (active.length === 1 ? '1 producto' : active.length + ' productos') + '<small>Ver o quitar</small></span>' + CHEVRON + '</button>' +
        '<ol class="sb-r__list"' + (open ? '' : ' hidden') + '>' + all.map(function (p) {
          var off = !!removed[p.handle];
          return '<li class="' + (off ? 'is-off' : '') + '"><button type="button" class="sb-r__ph" data-sb-view="' + esc(p.handle) + '" aria-label="Ver ' + esc(p.title) + '">' + pic(p, 56) + '</button><span class="sb-r__i"><small>' + esc(p.paso) + '</small><b>' + esc(p.title) + '</b><em>' + soles(p.price) + '</em></span>' +
            '<button type="button" class="sb-r__x" data-sb-rm="' + esc(p.handle) + '">' + (off ? 'Volver a agregar' : 'Quitar') + '</button></li>';
        }).join('') + '</ol>' +
        '<div class="sb-r__sum"><span>Total</span><b>' + soles(total) + '</b></div>' +
        (FREE ? '<small class="sb-r__free">' + (left <= 0 ? 'Incluye envío gratis' : 'Te faltan ' + soles(left) + ' para el envío gratis') + '</small>' : '') +
        '<button type="button" class="sb-cta" data-sb-buyall' + (active.length ? '' : ' disabled') + '>Agregar a mi bolsa · ' + soles(total) + '</button>' +
        '<button type="button" class="sb-r__again" data-restart>Repetir test</button></div>';
      if (card$.getBoundingClientRect().top < 0) card$.scrollIntoView({ behavior: RM ? 'auto' : 'smooth', block: 'start' });
    }
    card$.addEventListener('click', function (e) {
      var o = e.target.closest('[data-v]');
      if (o) { ans[qDef(qi).k] = o.dataset.v; qi++; renderQuiz(); return; }
      if (e.target.closest('[data-back]')) { qi--; renderQuiz(); return; }
      if (e.target.closest('[data-restart]')) { qi = 0; ans = {}; renderQuiz(); return; }
      if (e.target.closest('[data-sb-toggle]')) { open = !open; renderResult(); return; }
      var r = e.target.closest('[data-sb-rm]');
      if (r) { var h = r.dataset.sbRm; if (removed[h]) delete removed[h]; else removed[h] = 1; renderResult(); return; }
      var all = e.target.closest('[data-sb-buyall]');
      if (all) addToCart(res.items.filter(function (p) { return !removed[p.handle]; }).map(function (p) { return p.handle; }), all);
    });

    /* ---------- clics comunes ---------- */
    root.addEventListener('click', function (e) {
      var c = e.target.closest('[data-sb-cat]'); if (c) { openCat(c.dataset.sbCat, !e.target.closest('.sb-chips')); return; }
      var v = e.target.closest('[data-sb-view]'); if (v) { view(v.dataset.sbView); return; }
      var b = e.target.closest('[data-sb-buy]'); if (b) addToCart([b.dataset.sbBuy], b);
    });

    /* ---------- virales ---------- */
    var vir = (root.dataset.virales || '').split(',').map(function (h) { return byH(h.trim()); }).filter(Boolean);
    $('[data-sb-virales]').innerHTML = vir.map(card).join('');

    /* ---------- menú fijo ---------- */
    var nav = $('[data-sb-nav]'), links = $$('[data-sb-nav] a');
    var secs = links.map(function (a) { return document.getElementById(a.getAttribute('href').slice(1)); });
    function headerH() {
      var w = document.querySelector('.header__wrapper'), h = document.querySelector('.theme__header');
      if (!w || getComputedStyle(w).position === 'static') return 0;
      return Math.max(0, Math.round(Math.max(w.getBoundingClientRect().bottom, h ? h.getBoundingClientRect().bottom : 0)));
    }
    function onScroll() {
      var off = headerH(); nav.style.top = off + 'px'; root.style.setProperty('--sb-off', (off + nav.offsetHeight) + 'px');
      var cur = 0; secs.forEach(function (s, i) { if (s.getBoundingClientRect().top < window.innerHeight * .4) cur = i; });
      links.forEach(function (a, i) {
        var on = i === cur; if (on !== a.classList.contains('is-on')) { a.classList.toggle('is-on', on); if (on) nav.firstElementChild.scrollTo({ left: a.offsetLeft - 16, behavior: 'auto' }); }
      });
    }
    /* alto del banner en computadora: lo que queda de pantalla bajo la cabecera y la barra de pasos */
    var hero = $('.sb-hero');
    function fitHero() {
      if (!hero) return;
      root.style.setProperty('--sb-top', Math.round(hero.getBoundingClientRect().top + window.scrollY) + 'px');
      root.style.setProperty('--sb-navh', nav.offsetHeight + 'px');
    }
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', function () { onScroll(); fitHero(); });
    renderQuiz(); onScroll(); fitHero();
  }

  function boot() { document.querySelectorAll('[data-sb]').forEach(function (el) { if (!el.dataset.sbReady) { el.dataset.sbReady = '1'; init(el); } }); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', boot);
})();
